import React from "react";
import PropTypes from "prop-types";

const DualItem = (props) => {
  const { config } = props;
  return (
    <li className={config.class}>
      {config.text}
      {config.ids || config.default ? (
        <React.Fragment>
          <span id={config.ids[0]}>{config.default}</span>
          &nbsp;&nbsp;
          <span id={config.ids[1]}></span>
        </React.Fragment>
      ) : (
        ""
      )}
    </li>
  );
};

DualItem.propTypes = {
  config: PropTypes.object.isRequired,
};

export default DualItem;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Content/DualItem.js